import { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import { Box } from '@evaneos/b2b-ui';

type VisuallyHiddenProps = PropsWithChildren<ComponentPropsWithoutRef<'span'>>;

export const VisuallyHidden = ({ children, ...props }: VisuallyHiddenProps) => {
    return (
        <Box
            component="span"
            sx={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: 0,
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(100%)',
                whiteSpace: 'nowrap',
                border: 0,
            }}
            {...props}
        >
            {children}
        </Box>
    );
};
